var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DataRequest_1;
import './filter'; // force import for JsonSchemaV2
import { JSON, JsonDiscriminatorProperty, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { dataRequestSchemaValidation } from '../validations.generated';
export var RequestType;
(function (RequestType) {
    RequestType["Sample"] = "sample";
    RequestType["Run"] = "run";
    RequestType["Data"] = "data";
    RequestType["Malformed"] = "malformed";
    RequestType["Pipe"] = "pipe";
    RequestType["SampleVisual"] = "sample_visual";
    RequestType["RunVisual"] = "run_visual";
    RequestType["DataVisual"] = "data_visual";
    RequestType["PipeVisual"] = "pipe_visual";
    RequestType["SampleStats"] = "sample_stats";
    RequestType["PipeStats"] = "pipe_stats";
    RequestType["DataStats"] = "data_stats";
    RequestType["RunStats"] = "run_stats";
    RequestType["PipeStatsV2"] = "pipe_stats_v2";
    RequestType["DataStatsV2"] = "data_stats_v2";
    RequestType["RunStatsV2"] = "run_stats_v2";
})(RequestType || (RequestType = {}));
export const dataRequestSchema = {
    $id: 'urn:wisepipe-common-computation:DataRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        runID: { type: 'string' },
        requestType: { type: 'string', enum: Object.values(RequestType) },
        filters: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-computation:Filter' },
            maxItems: 20
        }
    },
    required: ['requestType']
};
let DataRequest = DataRequest_1 = class DataRequest {
    constructor(requestType, filters, pipeID, runID) {
        this.requestType = requestType;
        if (filters)
            this.filters = filters;
        if (pipeID)
            this.pipeID = pipeID;
        if (runID)
            this.runID = runID;
        JSON.validate(this, DataRequest_1);
    }
};
DataRequest = DataRequest_1 = __decorate([
    JsonSchemaV2(dataRequestSchema, dataRequestSchemaValidation),
    JsonDiscriminatorProperty('requestType')
], DataRequest);
export { DataRequest };
//# sourceMappingURL=dataRequest.js.map